import {AxiosInstance, AxiosResponse} from 'axios';
//api
import {orgAPI} from '@/core/api';
//types
import {
	IOrganizationAuctionCategory,
	IOrganizationAuctionListRequest,
	IOrganizationAuctionListResponse,
	IOrganizationAuctionUpdateRequest,
	IOrganizationAuctionResponse,
	IOrganizationCreateAuctionRequest,
	IOrganizationAuctionBidResponse,
	IOrganizationAuctionBidRequest,
	IOrganizationPresignedUrls,
	IOrganizationAuctionWonListResponse,
} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class OrganizationAuctionService {
	static getAuctionList = async (
		reqBody: IOrganizationAuctionListRequest
	): Promise<AxiosResponse<IOrganizationAuctionListResponse>> => orgAPI.post(API_URL.AUCTION, reqBody);

	static getAuctionCategories = async (
		apiInstance: AxiosInstance
	): Promise<AxiosResponse<IOrganizationAuctionCategory[]>> => apiInstance.get(API_URL.AUCTION_CATEGORY);

	static getAuctionBids = async (
		reqBody: IOrganizationAuctionBidRequest
	): Promise<AxiosResponse<IOrganizationAuctionBidResponse>> => orgAPI.post(API_URL.BIDS, reqBody);

	static getAuction = async (
		id: number,
		apiInstance: AxiosInstance
	): Promise<AxiosResponse<IOrganizationAuctionResponse>> => apiInstance.get(`${API_URL.AUCTION}/${id}`);

	static updateAuction = async (
		id: number,
		reqBody: IOrganizationAuctionUpdateRequest
	): Promise<AxiosResponse<IOrganizationAuctionResponse>> => orgAPI.put(`${API_URL.AUCTION}/${id}`, reqBody);

	static deleteAuction = async (id: number): Promise<AxiosResponse> => orgAPI.delete(`${API_URL.AUCTION}/${id}`);

	static createAuction = async (reqBody: IOrganizationCreateAuctionRequest): Promise<AxiosResponse> =>
		orgAPI.post(API_URL.AUCTION_CREATE, reqBody);

	static getPresingUrl = async (): Promise<AxiosResponse<IOrganizationPresignedUrls[]>> =>
		orgAPI.get(API_URL.PRESIGN_IMAGE);

	static getPresingUrlForDonor = async (): Promise<AxiosResponse<IOrganizationPresignedUrls>> =>
		orgAPI.get(API_URL.PRESIGN_IMAGE_DONOR);

	static createDonor = async (id: number, reqBody: {name: string; logo: string}): Promise<AxiosResponse> =>
		orgAPI.post(`${API_URL.AUCTION}/${id}/donor`, reqBody);

	static updateDonor = async (id: number, reqBody: {name: string; logo: string}): Promise<AxiosResponse> =>
		orgAPI.put(`${API_URL.AUCTION_DONOR}/${id}`, reqBody);

	static deleteDonor = async (id: number): Promise<AxiosResponse> => orgAPI.delete(`${API_URL.AUCTION_DONOR}/${id}`);

	static getAuctionActiveTime = async (id: number): Promise<AxiosResponse> =>
		orgAPI.get(`${API_URL.AUCTION_ACTIVE_TIME}?eventId=${id}`);

	static updateAuctionPaymentStatus = async (id: number, isPaid: boolean): Promise<AxiosResponse> =>
		orgAPI.put(`${API_URL.AUCTION}/${id}/paymentStatus?isPaid=${isPaid}`);

	static getAuctionWonList = async (
		id: number,
		reqBogy: IOrganizationAuctionListRequest
	): Promise<AxiosResponse<IOrganizationAuctionWonListResponse>> =>
		orgAPI.post(`${API_URL.AUCTION_WON_ITEMS}/${id}`, reqBogy);

	static getAuctionUnBidedItems = async (id: number): Promise<AxiosResponse<number>> =>
		orgAPI.get(`${API_URL.AUCTION}?eventId=${id}`);
}

export {OrganizationAuctionService};
